import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CoreTable from "../../coreComponents/Table/Table.tsx";
import { getAllFares } from "../../services/FareService.ts";
import Button from "../../coreComponents/Button/Button.tsx";
import { Fare } from "./types.ts";



const columns = [
  { id: "id", label: "ID" },
  { id: "vehicle_type", label: "Vehicle Type" },
  { id: "fare_type", label: "Fare Type" },
  { id: "base_distance", label: "Base Distance" },
  { id: "base_fare", label: "Base Fare" },
  { id: "per_km_fare", label: "Per KM Fare" },
  { id: "geozone_id", label: "GeoZone Id" },
];

const FareManagement: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<Fare[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
  const fetchFareData = async () => {
    try {
      const response = await getAllFares();
      if (response.data) {
        console.log(response.data);
        setData(response.data);
      }
    } catch (err: any) {
      if (err.response && err.response.status === 401) {
        console.error("Unauthorized access. Redirecting to login...");
        navigate("/login");
      } else {
        setError("Failed to fetch fare information");
        console.log(err);
      }
    } finally {
      setLoading(false);
    }
  };

  fetchFareData();
  }, []);


  const handleUpdate = (id: number) => {
    console.log(`Update User with ID: ${id}`);
  };

  const handleDelete = async (id: number) => {
    console.log(`Delete User with ID: ${id}`);
  };

  const handleCreateFare = () => {
    console.log(`Create Fare`);
  }

  if (loading && data.length === 0) return <div>Loading Fares...</div>;

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <CoreTable
        columns={columns}
        data={data}
        // onUpdate={handleUpdate}
        // onDelete={handleDelete}
      />
    </div>
  );
};

export default FareManagement;
